export enum StoreDocsActions {
    SET_STOREDOCS = "setSelectedStoreDocs",
    CLEAR_LIST_DATA = "clearListData",
    SET_ACTIVE_STOREDOC = "setActiveStoreDoc",
    RELOAD_DATA = "reloadData",
    TOGGLE_PANEL = "togglePanel",
    ADD_NEW_STOREDOC = "addNewStoreDoc",
    SET_APPROVE= "setApprove",
    SET_CANCEL = "setCancel"
}